/* ============================================================================
   Wehle · Knorpel Komplex Forte — Redesign
   Upload to: THEME ASSETS as  le-r-forte.js

   The add-to-cart path deliberately replicates LE-11b-produkt-bogos exactly:
   POST id+quantity to cart/add.js, then fire the theme's own cart events so the
   cart drawer opens. The free bags (1x/2x Gratis) are added app-side by BOGOS
   from cart rules — this script must NOT add them as line items.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__whInit) return;
    root.__whInit = true;

    var form       = root.querySelector('[data-wh-form]');
    var idInput    = root.querySelector('[data-wh-id]');
    var qtyInput   = root.querySelector('[data-wh-qty]');
    var tiers      = [].slice.call(root.querySelectorAll('[data-wh-tier]'));
    var cta        = root.querySelector('[data-wh-cta]');

    /* ── tier picker ─────────────────────────────────────────────────────── */
    function selectTier(el) {
      tiers.forEach(function (t) { t.setAttribute('aria-checked', t === el ? 'true' : 'false'); });
      if (idInput)  idInput.value  = el.getAttribute('data-variant-id') || '';
      if (qtyInput) qtyInput.value = el.getAttribute('data-quantity') || '1';
      syncSticky(el);
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { selectTier(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selectTier(t); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          var n = tiers[(tiers.indexOf(t) + 1) % tiers.length]; n.focus(); selectTier(n);
        }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var p = tiers[(tiers.indexOf(t) - 1 + tiers.length) % tiers.length]; p.focus(); selectTier(p);
        }
      });
    });

    /* ── sticky CTA ──────────────────────────────────────────────────────── */
    var sticky      = document.querySelector('[data-wh-sticky]');
    var stickyPrice = sticky && sticky.querySelector('[data-wh-sticky-price]');
    var stickyTier  = sticky && sticky.querySelector('[data-wh-sticky-tier]');

    function syncSticky(el) {
      if (!sticky || !el) return;
      if (stickyPrice) stickyPrice.textContent = el.getAttribute('data-price') || '';
      if (stickyTier)  stickyTier.textContent  = el.getAttribute('data-label') || '';
    }
    syncSticky(root.querySelector('[data-wh-tier][aria-checked="true"]'));

    if (sticky) {
      var anchor = document.getElementById('angebot');
      if ('IntersectionObserver' in window && anchor) {
        // show once the hero CTA has scrolled away, hide again over the offer itself
        var hero = document.querySelector('[data-wh-hero-cta]');
        var show = false, overOffer = false;
        var paint = function () { sticky.classList.toggle('is-in', show && !overOffer); };
        if (hero) {
          new IntersectionObserver(function (es) {
            show = !es[0].isIntersecting; paint();
          }, { threshold: 0 }).observe(hero);
        } else { show = true; }
        new IntersectionObserver(function (es) {
          overOffer = es[0].isIntersecting; paint();
        }, { threshold: 0 }).observe(anchor);
      } else {
        sticky.classList.add('is-in');
      }
    }

    /* ── gallery ─────────────────────────────────────────────────────────── */
    var main   = root.querySelector('[data-wh-gal-main]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-wh-gal-thumb]'));
    var track  = root.querySelector('[data-wh-gal-track]');
    var gPrev  = root.querySelector('[data-wh-gal-prev]');
    var gNext  = root.querySelector('[data-wh-gal-next]');

    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-src'), alt = b.getAttribute('data-alt') || '';
        if (main && src) { main.src = src; main.alt = alt; }
        thumbs.forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    });

    /* thumbnail carousel — the tiles are a fixed size now and overflow the rail */
    if (track) {
      var syncArrows = function () {
        var max = track.scrollWidth - track.clientWidth;
        /* 2px slack: sub-pixel widths never settle exactly on the bounds */
        if (gPrev) gPrev.hidden = track.scrollLeft <= 2;
        if (gNext) gNext.hidden = max <= 2 || track.scrollLeft >= max - 2;
      };
      var page = function (dir) {
        track.scrollBy({ left: dir * Math.max(80, track.clientWidth * 0.8), behavior: 'smooth' });
      };
      if (gPrev) gPrev.addEventListener('click', function () { page(-1); });
      if (gNext) gNext.addEventListener('click', function () { page(1); });
      track.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);
      if (window.ResizeObserver) { new ResizeObserver(syncArrows).observe(track); }
      syncArrows();

      /* keep the selected tile reachable when the main image changes */
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          var t = b.getBoundingClientRect(), r = track.getBoundingClientRect();
          if (t.left < r.left || t.right > r.right) {
            track.scrollBy({ left: t.left - r.left - (r.width - t.width) / 2, behavior: 'smooth' });
          }
        });
      });
    }

    /* ── collapsible buy-box review (mobile) ─────────────────────────────── */
    var coll = root.querySelector('[data-wh-collapsible]');
    if (coll) {
      var quote = coll.querySelector('p');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wh-buy__testi-more';
      btn.setAttribute('aria-expanded', 'false');
      if (quote) {
        quote.id = quote.id || 'wh-testi-quote';
        btn.setAttribute('aria-controls', quote.id);
      }
      var LESS = 'Weniger anzeigen', MORE = 'Mehr lesen';
      btn.textContent = MORE;
      btn.addEventListener('click', function () {
        var open = coll.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? LESS : MORE;
      });
      /* collapsed is the default; the class also gates the CSS clamp so the
         quote is never clipped when JS hasn't run */
      coll.classList.add('is-collapsible');
      coll.insertBefore(btn, coll.querySelector('footer'));
    }

    /* ── add to cart — mirrors LE-11b-produkt-bogos ──────────────────────── */
    if (form) {
      form.addEventListener('submit', function (e) {
        var id = idInput ? idInput.value : '';
        if (!id) return;
        e.preventDefault();
        if (cta) cta.setAttribute('aria-busy', 'true');

        var base = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
        var qv   = (qtyInput && qtyInput.value) || '1';
        var toCheckout = form.getAttribute('data-to-checkout') === 'true';

        var fd = new FormData();
        fd.append('id', id);
        fd.append('quantity', qv);

        if (!toCheckout) {
          var sections = ['variant-added'];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true, detail: { sections: sections }
          }));
          fd.append('sections', sections.join(','));
          fd.append('sections_url', base + 'variants/' + id);
        }

        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        }).then(function (res) {
          return res.json().then(function (rj) { return { ok: res.ok, rj: rj }; });
        }).then(function (o) {
          if (!o.ok) {
            if (cta) cta.removeAttribute('aria-busy');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            return;
          }
          if (toCheckout) { window.location.href = base + 'checkout'; return; }
          return fetch(base + 'cart.js').then(function (c) { return c.json(); }).then(function (cart) {
            cart.sections = o.rj.sections;
            var items = o.rj.items ? o.rj.items : [o.rj];
            document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
              bubbles: true, detail: { items: items, cart: cart }
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true, detail: { baseEvent: 'variant:add', cart: cart }
            }));
            if (cta) cta.removeAttribute('aria-busy');
          });
        }).catch(function () {
          if (cta) cta.removeAttribute('aria-busy');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
      });
    }
  }

  /* ── reveal on scroll (page-level, opt-in) ───────────────────────────────── */
  function initReveal() {
    var scope = document.querySelector('.wh[data-reveal="1"]');
    if (!scope) return;
    var els = [].slice.call(scope.querySelectorAll('[data-reveal]'));
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ── smooth scroll to #angebot ──────────────────────────────────────────── */
  function initAnchor() {
    if (window.__whAnchor) return;
    window.__whAnchor = 1;
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href$="#angebot"]') : null;
      if (!a) return;
      var el = document.getElementById('angebot');
      if (!el) return;
      e.preventDefault();
      window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - 76), behavior: 'smooth' });
    });
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-wh-offer]')).forEach(init);
    initReveal();
    initAnchor();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Shopify theme editor re-renders sections without a page load
  document.addEventListener('shopify:section:load', boot);
})();
